 <template>
  <div>
    <b-container fluid>
      <b-row style="margin-Top:3.5rem;margin-left:3.5rem;margin-right:3.5rem;height:80vh" no-gutters>
        <b-col lg="4" style="display:flex; flex-direction:column">
          <!-- <b-badge>{{window.document.location.href}}</b-badge> -->
            <template v-if="$route.query.campaign != 'remote'">
            <div class="bigTitle">Meetings that Make Stuff Happen</div>
            <p class="subTitle">Moogenda lets you create fun, effective meetings that accelerate your projects.</p>
            </template>

            <template v-if="$route.query.campaign === 'remote'">
            <div class="bigTitle">Effective Meetings for Remote Teams</div>
            <p class="subTitle">Moogenda keeps your meetings focussed and effective when your team is all over the place.</p>
            </template>

            <div class="signUp" v-if="!showGoogle()">
              <a href="#" class="cta" @click="modalShowStartNow=true">Get Started Now</a><br>
            </div>

        </b-col>
        <b-col>
            <img class="bigImage" src="@/assets/HomePageImage.png">
        </b-col>
      </b-row>

      <!-- <b-row style="Xheight: 38rem; min-height:85vh; margin:0 3rem">
        <b-col sm="4" style="Xpadding-bottom: 4rem">
          <div style="display:flex;flex-direction:column;justify-content:space-around;height:100%;">
            <div style="display: block;Xmargin-bottom:6rem">
              <div class="bigTitle">Meetings that Make Stuff Happen</div>
              <p class="subTitle">Moogenda helps you create fun and effective meetings that speed up your projects.</p>
            </div>
              <div class="signUp" v-if="showGoogle()">
                <b-btn class="login" variant="link" @click="loginGoogle()"><img src="@/assets/btn_google_signin_dark_normal_web.png"/></b-btn>
                <div class="terms">By signing in you agree to Moogenda's <router-link to="/tos">Terms of Service</router-link> and <router-link to="/privacypolicy">Privacy Policy</router-link>.</div>
              </div>
              <div class="signUp" v-if="!showGoogle()">
                <a href="#" class="cta" @click="modalShowForm=true">Register for Early Access</a><br>
                <div class="terms">By registering for early access you agree to Moogenda's <router-link to="/tos">Terms of Service</router-link> and <router-link to="/privacypolicy">Privacy Policy</router-link>.</div>
              </div>
          </div>


        </b-col>
        <b-col sm="8" style="justify-content: center; display: flex; flex-direction: column;">
          <img class="bigImage" src="@/assets/HomeImage.png">
        </b-col>
      </b-row> -->

      <b-row style="min-height: 50vh;padding:2rem 3rem; background-color: var(--lightGray)">
      <b-col sm="4" style="text-align: center">
        <h1>Clear Professional Looking Agendas</h1>
        <img src="@/assets/ClearObjectivesAgenda.png">
        <p class="featureBenefit">Create and share your meeting agenda in seconds so your meetings are well planned and effective.</p>
      </b-col>
      <b-col sm="4" style="text-align: center">
        <h1>Meetings That Deliver Your Projects</h1>
        <img src="@/assets/MeetingsDriveProjects.png">
        <p class="featureBenefit">Record actions, decisions and notes while you run the meeting so you can share them instantly.</p>
      </b-col>
      <b-col sm="4" style="text-align: center">
        <h1>More Engagement Means Better Decision Making</h1>
        <img src="@/assets/FocussedEngaged.png">
        <p class="featureBenefit">Record people's mood and talk about it. Countdown timer keeps meetings focussed and on time.</p>
      </b-col>
      </b-row>

      <b-row>
        <b-col style="margin-top:2rem"><h1>Our Clients</h1></b-col>
      </b-row>
      <b-row style="height:auto;padding:2rem 0">
        <b-col align-self="center" lg="2">
          <div><img src="@/assets/Green-Earth-Final.png" style="width:10.5rem; "></div>
        </b-col>
        <b-col align-self="center" class="socialProofRight" lg="4">
          <div class="socialQuote">"Moogenda Helps us get the most out of our weekly editorial meeting and follow through on decisions."</div>
          Green Earth Family, Environmental Blog
        </b-col>
        <b-col align-self="center" class="socialProofLeft" lg="2">
          <div><img src="@/assets/Rohit.png"></div>
        </b-col>
        <b-col align-self="center" class="socialProofRight" lg="4">
          <div class="socialQuote">"Moogenda helped me improve the way we use meetings and played a major part in our project's success!"</div>
          Rohit Mathur, Astute Consulting
        </b-col>
      </b-row>

      <b-row align-h="center" style="margin-top:2rem;padding-bottom: 1rem; background-color: var(--lightGray)">
      <b-col cols="12" style="text-align: center;margin-top:2rem">
        <h1>Fast Productive Meetings</h1>
      </b-col>
      </b-row>
      <b-row style="height:auto; background-color: var(--lightGray)" align-h="center" no-gutters>
        <b-col sm="4" cols="6" align-self="center">
          <div class="fbSpacer">
            <h1>Stay on Schedule</h1>
            <p class="featureBenefit">Create a time slot for each agenda item to stay on track.</p>
          </div>
          <div class="fbSpacer">
            <h1>Identify Project Blockers</h1>
            <p class="featureBenefit">Call out what's blocking your project and assign actions to unblock it.</p>
          </div>
        </b-col>
        <b-col sm="4" cols="6" align-self="center" style="text-align: center">
          <img src="@/assets/340500Image.png">
        </b-col>
        <b-col sm="4" align-self="center">
          <div class="fbSpacer">
            <h1>Create Positive Energy</h1>
            <p class="featureBenefit">Recognising how people feel about work helps reduce negativtiy and boost performance.</p>
          </div>
          <div class="fbSpacer">
            <h1>Send Minutes Instantly</h1>
            <p class="featureBenefit">Email your attendees with  minutes as soon as the meeting ends and avoid delays.</p>
          </div>
        </b-col>
      </b-row>

      <b-row style="margin-top:2rem">
        <b-col>
          <h1>Plans & Pricing </h1>
        </b-col>
      </b-row>
      <b-row style="margin:2rem 6rem 4.5rem 6rem">
        <b-col lg="4" >
          <div class="plan">
           <h1>Free</h1>
           <div class="planDesc">Limited to 3 meetings per week</div>
           <div class="planPrice"><h1>No cost</h1></div>
           <div class="planCTA">
             <div style="margin: 0; padding-top:1.6rem">
               <a class="cta" @click="modalShowSignUp=true">Start Now</a>
            </div>
           </div>
           <hr>
           <div class="planDetail">
             <font-awesome-icon  :icon="['fas', 'check']" xsize="lg"  class="planIcon"/>&nbsp;
             Create 3 meetings per week
           </div>
         </div>
        </b-col>
        <b-col lg="4">
          <div class="plan">
          <h1>Personal</h1>
          <div class="planDesc">Unlimited access</div>
          <div class="planPrice"><h1>£28 per month</h1></div>
          <div class="planCTA">
            <div style="margin: 0; padding-top:1.6rem">
              <a class="cta" @click="modalShowSignUpPersonal=true">Sign Up</a>
            </div>
          </div>
          <hr>
          <div class="planDetail">
            <font-awesome-icon  :icon="['fas', 'check']" xsize="lg"  class="planIcon"/>&nbsp;
            Unlimited meetings
          </div>
        </div>
        </b-col>
        <b-col lg="4">
          <div class="plan">
          <h1>Team</h1>
          <div class="planDesc">Access for your entire team</div>
          <div class="planPrice"><h1>£98 per month</h1></div>
          <div class="planCTA">
            <div style="margin: 0; padding-top:1.6rem">
              <a class="cta" target="new" @click="modalShowStartNow=false;modalShowForm=true">Contact Us</a>
            </div>
          </div>
          <hr>
          <div class="planDetail">
            <font-awesome-icon  :icon="['fas', 'check']" xsize="lg"  class="planIcon"/>&nbsp;
            Unlimited meetings<br>
            <font-awesome-icon  :icon="['fas', 'check']" xsize="lg"  class="planIcon"/>&nbsp;
            Access for up to 30 users
          </div>

        </div>
        </b-col>
      </b-row>

      <b-row style="height:16rem;background-color: var(--lightGray)">
        <b-col cols="12" align-self="center" style="text-align: center;display: flex;flex-direction: column;justify-content: center">
          <h1>Start creating new kinds of meeting</h1>
          <div v-if="showGoogle()">
            <b-btn class="login" variant="link" @click="loginGoogle()"><img src="@/assets/btn_google_signin_dark_normal_web.png"/></b-btn><
            <div class="terms">By signing in you agree to Moogenda's <router-link to="/tos">Terms of Service</router-link> and <router-link to="/privacypolicy">Privacy Policy</router-link>.</div>
          </div>
           <div v-if="!showGoogle()" style="margin:2rem 0">
              <a class="cta" @click="modalShowSignUp=true">Start Now</a>
              <div class="terms">By registering for early access you agree to Moogenda's <router-link to="/tos">Terms of Service</router-link> and <router-link to="/privacypolicy">Privacy Policy</router-link>.</div>
            </div>
        </b-col>
      </b-row>

    </b-container>

    <!-- Modal for Free Start Now CTA -->
    <b-modal Xid="modalSignUp" hide-footer="true" size="lg" v-model="modalShowSignUp" title="Create Your Free Moogenda Account">
     <p class="modalMessage">Welcome to Moogenda!  Sign in with Google to create your account and start creating new types of meeting.</p>
      <div style="Xmin-height:20rem;display:flex;flex-direction: column;align-items:center;justify-content: center">
        <b-btn id="SignUpGoogle" variant="link" @click="signUp()"><img src="@/assets/btn_google_signin_light_focus_web.png"/></b-btn><br />

        <div class="terms" style="margin-bottom: 2rem">By signing up you agree to Moogenda's <router-link to="/tos">Terms of Service</router-link> and <router-link to="/privacypolicy">Privacy Policy</router-link>.</div>

     </div>
     </b-modal>

     <!-- Modal for Start Now CTA at top of the page -->
     <b-modal size="lg" hide-footer v-model="modalShowStartNow" title="Create your Moogenda Account">
       <p>
         Thanks for signing up for Moogenda!  Select one of the options to get started:
       </p>

       <b-container fluid>
         <b-row style="margin:2rem 0 4.5rem 0">
           <b-col lg="4" >
             <div class="plan">
              <h1>Free</h1>
              <div class="planDesc">Limited to 3 meetings per week</div>
              <div class="planPrice"><h1>No cost</h1></div>
              <div class="planCTA">
                <!-- <b-btn id="SignUpGoogle" variant="link" @click="loginGoogle()"><img src="@/assets/btn_google_signin_light_focus_web.png"/></b-btn><br /> -->
                <b-btn variant="link" @click="signUp(false)" style="margin:0.7rem 0 0 0" ><img src="@/assets/btn_google_signin_light_focus_web.png"/></b-btn>
                <!-- <b-btn variant="link" @click="$emit('login')" style="margin:0.7rem 0 0 0" ><img src="@/assets/btn_google_signin_light_focus_web.png"/></b-btn> -->
              </div>
              <hr>
              <div class="planDetail">
                <font-awesome-icon  :icon="['fas', 'check']" xsize="lg"  class="planIcon"/>&nbsp;
                Create 3 meetings per week
              </div>
            </div>
           </b-col>
           <b-col lg="4">
             <div class="plan">
             <h1>Personal</h1>
             <div class="planDesc">Unlimited access</div>
             <div class="planPrice"><h1>£28 per month</h1></div>
             <div class="planCTA">
               <!-- <a class="cta" @click="modalShowStartNow=false;modalShowSignUpPersonal=true">Sign Up</a> -->
               <!-- <b-btn id="SignUpGoogle" style="margin:0.7rem 0 0 0" variant="link" @click="modalShowStartNow=false;loginGoogle('/home?showSignUpPersonal=y')"><img src="@/assets/btn_google_signin_light_focus_web.png"/></b-btn><br /> -->
               <b-btn id="SignUpGoogle" style="margin:0.7rem 0 0 0" variant="link" @click="signUp(true)"><img src="@/assets/btn_google_signin_light_focus_web.png"/></b-btn><br />

             </div>
             <hr>
             <div class="planDetail">
               <font-awesome-icon  :icon="['fas', 'check']" xsize="lg"  class="planIcon"/>&nbsp;
               Unlimited meetings
             </div>
           </div>
           </b-col>
           <b-col lg="4">
             <div class="plan">
             <h1>Team</h1>
             <div class="planDesc">Access for your entire team</div>
             <div class="planPrice"><h1>£98 per month</h1></div>
             <div class="planCTA">
               <div style="margin: 0; padding-top:1.6rem">
                 <a class="cta" target="new" @click="modalShowStartNow=false;modalShowForm=true"> Contact Us</a>
               </div>
             </div>
             <hr>
             <div class="planDetail">
               <font-awesome-icon  :icon="['fas', 'check']" xsize="lg"  class="planIcon"/>&nbsp;
               Unlimited meetings<br>
               <font-awesome-icon  :icon="['fas', 'check']" xsize="lg"  class="planIcon"/>&nbsp;
               Access for up to 30 users
             </div>

           </div>
           </b-col>
         </b-row>
       </b-container>

     </b-modal>

     <!-- Modal for Personal Sign Up -->
     <b-modal Xid="modalSignUp" hide-footer="true" size="lg" v-model="modalShowSignUpPersonal" title="Create Your Moogenda Account">
        <div v-if="!user">
          <b>Welcome to Moogenda!  Sign in with your Google account to get started:</b>
          <div style="display:flex;flex-direction:column;height: 16rem">
            <div class="socialSignUp">
            <b-btn id="SignUpGoogle" variant="link" @click="signUp(true)"><img src="@/assets/btn_google_signin_light_focus_web.png"/></b-btn>
          </div>

            <div class="signUpTerms" style="margin-bottom: 2rem">By signing up you agree to Moogenda's <router-link to="/tos">Terms of Service</router-link> and <router-link to="/privacypolicy">Privacy Policy</router-link>.</div>
          </div>
        </div>

         <div v-if="user">
           <b>You're signed in as: </b>
           <div style="display:flex;height: 4rem">
             <div style="width: 2.5rem; height:2rem; line-height: 2rem">
               <img :src="user.photoURL" style="height: 28px; width:28px; border-radius: 50%">
             </div>
             <div style="width: 20rem; height:1rem; line-height: 1rem">
               <span style="font-size: 14px">{{user.displayName}}</span>
               <br><span style="font-size: 12px">{{user.email}}</span>
             </div>
             <div style="width 3:rem">
               <font-awesome-icon  :icon="['fas', 'check-circle']" class="signUpIcon" size="2x"/>
             </div>
           </div>

           <div style="display:flex;height:8rem">
             <div style="width: 22.5rem">
               <b>Redirecting to payments form</b>
             </div>
             <div style="width 3:rem">
              <font-awesome-icon  :icon="['fas', 'spinner']" class="signUpIcon"  size="2x" spin/>
             </div>
          </div>
        </div>

      </b-modal>

     <b-modal hide-footer="true" size="lg" v-model="modalShowSignIn" title="Sign in to your  Moogenda Account">
      <p class="modalMessage">Welcome back to Moogenda!  Sign in with Google to access your account.</p>
       <div style="Xmin-height:20rem;display:flex;flex-direction: column;align-items:center;justify-content: center">
         <b-btn id="SignUpGoogle" variant="link" @click="loginGoogle()"><img src="@/assets/btn_google_signin_light_focus_web.png"/></b-btn>
         <div class="terms" style="margin-bottom: 2rem">By signing up you agree to Moogenda's <router-link to="/tos">Terms of Service</router-link> and <router-link to="/privacypolicy">Privacy Policy</router-link>.</div>
      </div>
      </b-modal>

    <!-- Contact Us Form-->
    <b-modal id="modal-1" xtitle="xRegister for Early Access" xsize="lg" v-model="modalShowForm">
       <template slot="modal-header" >
          <div class="modalTitle">Tell us your name and email address and we'll get back to you.</div>
      </template>
      <b-form v-if="formShow">
          <b-form-group id="firstNameGroup" label="First Name" lable-for="firstName" >
            <b-form-input type="text" id="firstName" v-model="earlyAccessForm.fields[1].value" Xstyle="width:25rem" autofocus :state="firstNameValid" ></b-form-input>
          <b-form-invalid-feedback id="inputLiveFeedback">Enter your first name.</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group id="lastNameGroup" label="Last Name" lable-for="lastName" >
            <b-form-input type="text" id="lastName" v-model="earlyAccessForm.fields[2].value" Xstyle="width:25rem" autofocus :state="lastNameValid" ></b-form-input>
            <b-form-invalid-feedback id="inputLiveFeedback">Enter your last name.</b-form-invalid-feedback>
          </b-form-group>
        <b-form-group id="emailGroup" label="Email" lable-for="email" >
            <b-form-input type="email" id="email" v-model="earlyAccessForm.fields[0].value" Xstyle="width:25rem" autofocus :state="emailValid" ></b-form-input>
            <b-form-invalid-feedback id="inputLiveFeedback">Enter a valid email address.</b-form-invalid-feedback>
          </b-form-group>
      </b-form>
      <div v-if="!formShow">
      Thanks for contacting us.  We will send you an email shortly.
      </div>
       <div slot="modal-footer" Xclass="w-100">
          <b-button v-if="formShow" variant="primary" size="sm" class="float-right" @click="registerEarlyAccess">Send</b-button>
          <b-button v-if="formShow" variant="secondary" size="sm" xclass="float-right" @click="modalShowForm=false">Cancel</b-button>
         <b-button v-if="!formShow" variant="secondary" size="sm" class="float-right" @click="modalShowForm=false">Close</b-button>&nbsp;&nbsp;
        </div>
    </b-modal>
  </div>
</template>

<script>
import {firebase, router} from '../main'
import PlanAndPricing from './landingPage/PlanAndPricing.vue'

const axios = require('axios')
export default {
  name: 'Home',
  props: ['user'],
  data () {
    return {
      formShow: true,
      validationOn: false,
      modalShowForm: false,
      modalShowSignUp: false,
      modalShowSignUpPersonal: false,
      modalShowSignIn: false,
      modalShowStartNow: false,
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      earlyAccessForm: {
        'submittedAt': Date.now(),
        'fields': [
          {
            'name': 'email',
            'value': ''
          },
          {
            'name': 'firstname',
            'value': ''
          },
          {
            'name': 'lastname',
            'value': ''
          }
        ]
      }
    }
  },
  computed: {
    firstNameValid () {
      return this.validationOn ? this.earlyAccessForm.fields[1].value !== '' : null
    },
    lastNameValid () {
      return this.validationOn ? this.earlyAccessForm.fields[2].value !== '' : null
    },
    emailValid () {
      // return this.validationOn ?  this.earlyAccessForm.fields[0].value !== '' : null
      if (this.validationOn) {
        // return (this.earlyAccessForm.fields[0].value == '') ? false : (this.reg.test(this.earlyAccessForm.fields[0].value)) ? true  : false
        return this.earlyAccessForm.fields[0].value !== '' && this.reg.test(this.earlyAccessForm.fields[0].value)
      } else {
        return true
      }
    },
    earlyAccessFormValid () {
      return this.firstNameValid && this.lastNameValid && this.emailValid
    }
  },
  methods: {
    createCalendarICS () {
      let now = new Date()
      let start = new Date(now.getFullYear(), now.getMonth() + 1, now.getDay(), now.getHours(), now.getMinutes(), 0, 0)
      let end = new Date(now.getFullYear(), now.getMonth() + 1, now.getDay(), now.getHours() + 1, now.getMinutes(), 0, 0)
      this.$ics.addEvent('en-us', 'Test event subject', 'Test event description', 'online', start, end, "http://test.com")
    },
    showGoogle () {
      return this.$route.query.beta !== undefined
    },
    signUp(stripeRedirect) {
      dataLayer.push({
        'event': 'SignUpGoogle'
      })
      this.$emit('login',stripeRedirect)
    },
    // loginGoogle (redirect) {
    //   // Trigger tag for Google Ads conversion tracking
    //   dataLayer.push({
    //     'event': 'SignUpGoogle'
    //   })
    //   var provider = new firebase.auth.GoogleAuthProvider()
    //   firebase.auth().signInWithPopup(provider).then(function (result) {
    //     // If
    //     if (redirect) {
    //       var stripeKey = process.env.VUE_APP_STRIPE_KEY
    //       var stripePersonalPlanId = process.env.VUE_APP_STRIPE_PERSONAL_ID
    //       var stripe = Stripe(stripeKey)
    //       setTimeout( () => {
    //         var port = window.location.port ? ':' + window.location.port : ''
    //         stripe.redirectToCheckout({
    //           items: [{plan: stripePersonalPlanId, quantity: 1}],
    //           successUrl: window.location.protocol + '//' + window.location.hostname + port + '/#/MyMeetings?WelcomePersonal=y',
    //           cancelUrl: window.location.protocol + '//' + window.location.hostname +  port + '/home',
    //           customerEmail: result.user.email
    //         }).then(function (result) {
    //           if (result.error) {
    //             console.log('Unable to process Payment')
    //             console.log(result.error)
    //           }
    //         })
    //       },5000)
    //     } else {
    //       router.replace('/MyMeetings?WelcomeFree=y')
    //     }
    //   })
    // },
    registerEarlyAccess () {
      this.validationOn = true
      if (this.earlyAccessFormValid === false) {
        this.formValid = false
        return
      }
      var hubSpotURL = 'https://api.hsforms.com/submissions/v3/integration/submit/5651844/482c8c70-acc5-4837-993e-9ce26a0fd39f'
      axios.post(hubSpotURL, this.earlyAccessForm)
        .then(response => {
          this.formShow = false
          var dataObject = {
            'event': 'SubmitEarlyAccess',
            'category': 'click',
            'label': 'label_submit_earlyaccess'
          }
          if (typeof dataLayer !== 'undefined') {
            dataLayer.push(dataObject)
          }
        }
        )
        .catch(error => {
          console.log(error.response)
        })
      }
    },
  components: {
    PlanAndPricing: PlanAndPricing
  }
}
</script>
<style scoped>

  .bigImage {width:100%}
  .subTitle{font-size:1.6rem;color:#262626;text-align: left;margin-top:1.1rem}
  .signUp {Xalign-self: flex-end;text-align: left;xtext-align: center; margin-top:2rem; margin-bottom: 4rem}
  /deep/ .cta {background-color:var(--primaryColor1); color:white !important;font-size:1.2rem; font-weight: bold;cursor:pointer; line-height: 2rem; padding: 0.5rem 1.5rem; border-radius: 10px}
  .panel {height: 100%}
   /deep/ h1{font-size:1.5rem;text-align: center;color:#98A0A6}
  .featureBenefit{color:#98A0A6;text-align: center}
  .fbSpacer{margin:0 0 8rem 0}
  .socialProofLeft {text-align: right}
  .socialProofRight {text-align: left}
  @media screen and (max-width: 540px){
    .socialProofLeft {text-align: center}
    .socialProofRight {text-align: center}
  }
  .socialQuote{font-size: 1.5rem;}

  .login {padding:0px}
  #__BVID__8___BV_modal_header_{background-color: yellow}
  .modalTitle{font-size:1.5rem; color:white}
  .modalMessage {font-size:1.3rem;color:#262626;text-align: left;margin-bottom:2rem}

  .plTitle {justify-content: center; display: flex;}
  .plDesc {height:3rem; Xmargin:0 1rem; display:flex; align-items: center;justify-content: center}
  .plCTA {display: flex; justify-content: center}
  .planDesc {text-align: center; height:3rem; }
  .planDetail {text-align: center; padding-bottom: 1rem; height: 5rem; }
  .planPrice {text-align: center;border-bottom:2px white solid; }
  /* .planCTA {background-color: pink; text-align: center;padding:1rem; min-height: 7rem;display: flex; flex-direction: column; justify-content: center; align-items: center;} */
  /* .planCTA {display:flex; justify-content: center;min-height:5rem} */
  .planCTA {height:4rem; padding: 0}
  .plan {box-shadow: 0 6px 12px -2px rgba(50,50,93,.25);padding-top: 1rem; margin:0 0rem}
  .planIcon {color: var(--primaryColor1)}
  .comingSoon {line-height: 2rem; padding: 0.5rem 1.5rem;}

  .signUpIcon {color: var(--primaryColor1)}

  .socialSignUp {margin:1rem 1rem 0 0}
  .signUpTerms {font-size:0.8rem; margin: 0 1rem; padding:0 }

</style>
